import React from "react";
import styled from "styled-components";
import { Typography, TypographyVariant } from "../../../../components/ui-kit";

const FullName = styled(Typography)`
  line-height: 20px;
`;

interface BillingNameColumnProps {
  firstName?: string;
  lastName?: string;
  name?: string;
}
export const BillingNameColumn: React.FunctionComponent<
  BillingNameColumnProps
> = ({ firstName, lastName, name }) => {
  return (
    <FullName variant={TypographyVariant.BODY3}>
      {name ?? (firstName && lastName ? `${firstName} ${lastName}` : null)}
    </FullName>
  );
};
